import { useContext } from "react";
import { FakeContext } from "../providers";

/**
 * Hook that returns the fake context value
 * Fake context is created to enable fake data
 * transmission between the plugin and the operator
 * webapp
 * 
 * @returns The fake context
 */
const useFake = () => {
  const fakeContext = useContext(FakeContext);

  if (!fakeContext) {
    throw new Error("useFake must be used within an FakeProvider");
  }
  return fakeContext;
};

export default useFake;
